import React from 'react';
import Text from '../Text';

import styles from './Landing.module.scss';

const renderBullet = () => (
  <div className={styles.bullet}>
    <img
      alt="Circle with a checkmark"
      src="/images/tscircle.png"
    />
  </div>
);

export default function Landing() {
  return (
    <div className={styles.list}>
      <div className={styles.listItem}>
        {renderBullet()}
        <div className={styles.text}>
          <h3>
            <Text value="Immediately Verify Your Identity" />
          </h3>
          <Text
            // eslint-disable-next-line max-len
            value="Fast-track your application and get the best possible approval by verifying your identity through your bank account."
          />
        </div>
      </div>
      <div className={styles.listItem}>
        {renderBullet()}
        <div className={styles.text}>
          <h3>
            <Text value="Securely Send Your Data" />
          </h3>
          <Text
            // eslint-disable-next-line max-len
            value="No more scans, faxes, emails or photocopies. Securely send your account information in seconds via the Smart Consent app."
          />
        </div>
      </div>
      <div className={styles.listItem}>
        {renderBullet()}
        <div className={styles.text}>
          <h3>
            <Text value="Avoid Re-Entry" />
          </h3>
          <Text
            // eslint-disable-next-line max-len
            value="Create a Smart Consent account and your profile will be saved in a secure digital wallet for any future transactions in the Smart Consent network."
          />
        </div>
      </div>
      <div className={styles.moreInfo}>
        <Text value="Contact your lender to submit your loan application through Smart Consent or visit" />
        <a href="https://www.trustscience.com/" aria-label="Trust Science Corporate Site">Trust Science</a>
        <Text value="for more information." />
      </div>
    </div>
  );
}
